module.exports = __webpack_public_path__ + "static/media/currency-calculator.29b15be4.png";